import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { style } from 'typestyle';
import { useNavigate } from 'react-router-dom';
import * as styles from './companies.styles';
import CompanyInfoGroup from './groups/company-info-group.component';
import BackButton from '../../core/components/back-button/back-button.component';
import PrimaryButton from '../../core/components/buttons/primary-button.component';
import Column from '../../core/components/column/column.component';
import { CrossAxisAlignment, MainAxisAlignment } from '../../core/components/flex/flex.component';
import Row from '../../core/components/row/row.component';
import { IsMobileContext } from '../../core/context/is-mobile';
import CommonStyles from '../../core/common.styles';
import RouteConstants from '../../core/routes.constants';

const CompanyCreate = (): React.JSX.Element => {
  const navigate = useNavigate();
  const isMobile = useContext(IsMobileContext);
  const { t } = useTranslation();

  const navigateToOverview = (): void => {
    navigate(`/${RouteConstants.PATH_COMPANIES}`);
  };

  return (
    <div className={style(styles.bottomMargin)}>
      {isMobile ? (
        <Column crossAxisAlignment={CrossAxisAlignment.Stretch} className={style(styles.cornerButton(isMobile))} itemSpacing={12}>
          <BackButton title={t('companies')} navigate={navigateToOverview} />
          <Row itemSpacing={12}>
            <PrimaryButton onClick={navigateToOverview}>{t('cancel')}</PrimaryButton>
          </Row>
        </Column>
      ) : (
        <Row className={style(styles.cornerButton(isMobile))} mainAxisAlignment={MainAxisAlignment.SpaceBetween}>
          <BackButton title={t('companies')} navigate={navigateToOverview} />
          <Row itemSpacing={12}>
            <PrimaryButton onClick={navigateToOverview}>{t('cancel')}</PrimaryButton>
          </Row>
        </Row>
      )}
      <div className={style(CommonStyles.bodyMargin(isMobile))}>
        <CompanyInfoGroup isCreatingCompany companyId={undefined} company={undefined} />
      </div>
    </div>
  );
};

export default CompanyCreate;
